import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ValidarContasReceberImportacaoRequest } from '../../requests/financas/importacao/validar-contas-receber-importacao.request';
import { ValidarContasReceberImportacaoResponse } from '../../responses/financas/importacao/validar-contas-receber-importacao.response';
import { ReturnStruct } from '../../structs/return.struct';
import { ItemValidacaoContasReceberStruct } from '../../structs/financas/importacao/item-validacao-contas-receber.struct';
import { ConfirmarContasReceberImportacaoRequest } from '../../requests/financas/importacao/confirmar-contas-receber-importacao.request';

@Injectable({
  providedIn: 'root'
})
export class ImportarContasReceberService extends CommonService {
  private apiUrl: string = environment.urlApiOrquestradorFinancas + 'ImportarContasReceber';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public validar(request: ValidarContasReceberImportacaoRequest): Observable<ValidarContasReceberImportacaoResponse> {
    return this.httpClient
      .post<ValidarContasReceberImportacaoResponse>(
        `${this.apiUrl}/validar`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError.bind(this)));
  }

  public confirmar(request: ConfirmarContasReceberImportacaoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/confirmar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
